import {globalCatch} from "../../../_services/global-catch";
import {svcPsService} from "../../../_services/ps-service";
import {SET_CERTIFICATE_TYPES, SET_PURCHASED_CERTIFICATES, SET_PRESTA_CERTIFICATES} from "./constants";
import {academicProgramsApi, certificatesApi} from "../../../_services/expedient-service";

export const setCertificateTypes = payload => ({type: SET_CERTIFICATE_TYPES, payload});
export const setPurchasedCertificates = purchasedCertificates => ({ type: SET_PURCHASED_CERTIFICATES, payload: purchasedCertificates });
export const setPrestaCertificates = ({ academicProgramId, certificates }) => ({
  type: SET_PRESTA_CERTIFICATES,
  payload: { academicProgramId, certificates }
});

export const fetchCertificateTypes = () =>
    globalCatch.catch(async (dispatch) => {
        const certTypes = await (await svcPsService()).getCertificateTypes();
        dispatch(setCertificateTypes(certTypes));
    })

export const createCertificateCart = (academic_program_id, product_attribute_id) =>
    globalCatch.catch(async (dispatch) => {
        let url = await (await svcPsService()).createCertificateCart(academic_program_id, product_attribute_id);
        window.open(url, '_self').focus()
    })
;

export const purchasedDocuments = (studentId, academicPogramId) => {
    return globalCatch.catch(async (dispatch) => {
       const response = await (await academicProgramsApi()).studentExpedientControllerGetAcademicProgramExpedient(studentId, academicPogramId);
       const payload = { [academicPogramId]: response.purchased_certificate };
       dispatch(setPurchasedCertificates(payload));
       return response;
    });
}

export const certificatesControllerGetPrestaCertificates = (academicProgramId) => {
    return globalCatch.catch(async (dispatch) => {
       const response = await (await certificatesApi()).certificatesControllerGetPrestaCertificates(academicProgramId);
       dispatch(setPrestaCertificates({ academicProgramId: academicProgramId, certificates: response }));
    });
}